import Vue from "vue";
import VueRouter from "vue-router";
import Default from "../layouts/Default.vue";
import store from '@/store'
import emarticonHome from "@/views/home/emarticonHome.vue";
import productDetail from '@/views/products/productDetail.vue';
import orderResult from '@/views/products/orderResult.vue';
import saveBox from "@/views/myemarticon/saveBox.vue";
import emarticonBefore2023 from "@/views/myemarticon/emarticonBefore2023.vue";
import myDetail from "@/views/myemarticon/mydetail/myDetail.vue";
import stopUsing from "@/views/myemarticon/stopUsing.vue";
import stopUsingCancel from "@/views/myemarticon/stopUsingCancel.vue";
import refund from "@/views/myemarticon/refund.vue";
import emarticonQuestions from "@/views/home/emarticonQuestions.vue"
import usageDetail from "@/views/myemarticon/usageDetail";
import reloadCash from "@/views/cards/reloadCash";
import cardDetail from "@/views/cards/cardDetail";
import errorPage from "@/components/common/ErrorPage"
import emarticonRegistration from "@/views/home/emarticonRegistration";
import paymentVoid from "@/views/myemarticon/paymentVoid"
import autoCharging from "@/views/cards/autoCharging";
import charging from "@/views/cards/charging";
import actions from "@/store/actions";
import cardDetailUse from "@/views/cardDetailUse";
import emarticonQuestionsWeb from "@/views/home/emarticonQuestionsWeb";
import emarticonGuide from "@/views/myemarticon/emarticonGuide.vue";
import awardCode from "@/views/award/awardCode";
import emarticonAwardHome from "@/views/award/emarticonAwardHome";
import awardDetail from "@/views/award/awardDetail";
import EmarticonMberPassword from "@/views/home/emarticonMberPassword.vue";
import setting from '@/views/myemarticon/setting.vue';
import commonScripts from "@/plugins/commonScripts";

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      // 이마티콘 홈
      path: "/home",
      name: 'home',
      component: emarticonHome,
      meta: { layout: Default, title: '이마티콘' },
    },
    {
      // 보관함
      path: "/myemarticon/savebox",
      name: "saveBox",
      component: saveBox,
      meta: { layout: Default, requiresAuth: true, title: '카드 보관함 < 이마티콘' },
    },
    {
      // 2023 이전 이마티콘
      path: "/myemarticon/before2023",
      name: "emarticonBefore2023",
      component: emarticonBefore2023,
      meta: { layout: Default, title: '카드 보관함 < 이마티콘' },
    },
    {
      // 상품 상세
      path: "/product/detail",
      name: "productDetail",
      component: productDetail,
      meta: { layout: Default, requiresAuth: true, title: '구매/선물하기 < 이마티콘' },
      props: true,
    },
    {
      // 주문 완료
      path: "/product/order-result",
      component: orderResult,
      meta: { title: '주문 완료 < 이마티콘'}
    },
    {
      // 카드 사용내역
      path: "/myemarticon/usage-detail",
      name: "usageDetail",
      component: usageDetail,
      meta: { layout: Default, requiresAuth: true, title : '사용내역 < 이마티콘' },
    },
    {
      // 일반충전
      path: "/myemarticon/reload-cash",
      name: "reloadCash",
      component: reloadCash,
      meta: { layout: Default , title: '일반 충전 < 이마티콘'},
    },
    {
      // 자주하는 질문
      path: "/emarticon/home/emarticonQuestions",
      name: "emarticonQuestions",
      component: emarticonQuestions,
      meta: { layout: Default , title: '자주하는 질문 < 이마티콘'},
    },
    {
      // 주문내역
      path: "/myemarticon/mydetail",
      name: "mydetail",
      component: myDetail,
      meta: { layout: Default, requiresAuth: true, title: '주문내역 < 이마티콘' },
    },
    {
      // 사용중지하기
      path: "/emarticon/myemarticon/stopUsing",
      name: "stopUsing",
      component: stopUsing,
      meta: { layout: Default, title: '사용 중지 신청 < 이마티콘' },
    },
    {
      //사용중지 취소하기
      path: "/myemarticon/stopUsingCancel",
      name: "stopUsingCancel",
      component: stopUsingCancel,
      meta: { layout: Default, title: '사용 중지 취소 < 이마티콘' },
    },
    {
      //환불신청
      path: "/myemarticon/refund",
      name: "refund",
      component: refund,
      meta: { layout: Default, title: '환불 < 이마티콘' },
    },
    { // 자동충전
      // 카드 상세내역
      path: "/card/detail",
      name: "cardDetail",
      component: cardDetail,
      meta: { layout: Default, title: '이마티콘 상세 < 이마티콘' },
      props: true,
    },
    { // 자동충전 설정
      // 에러 페이지
      path: "/error",
      name: "errorPage",
      component: errorPage,
    },
    {
      // 이마티콘 등록
      path: "/emarticon/home/emarticonRegistration",
      name: "emarticonRegistration",
      component: emarticonRegistration,
      meta: { layout: Default, requiresAuth: true, title: '이마티콘 등록 < 이마티콘' },
    },
    {
      // 이마티콘 구매취소
      path: "/myemarticon/paymentVoid",
      name: "paymentVoid",
      component: paymentVoid,
      meta: {layout: Default, title: '구매취소 < 이마티콘'},
      props: true,
    },
    {
      path: "/emarticon/card/autoCharging",
      name: "autoCharging",
      component: autoCharging,
      meta: { layout: Default, title: '자동충전 < 이마티콘' }
    },
    {
      path: "/emarticon/card/charging",
      name: "charging",
      component: charging,
      meta: { layout: Default, title: '자동 충전 < 이마티콘' }
    },
    { //비회원 사용내역 조회(MMS용)
      path: "/mobile",
      name: "cardDetailUse",
      component: cardDetailUse,
      meta: { layout: Default, title: '사용내역 < 이마티콘' },
    },
    { // 자주하는 질문(MMS용)
      path: "/emarticon/emarticonQuestionsWeb",
      name: "emarticonQuestionsWeb",
      component: emarticonQuestionsWeb,
      meta: { layout: Default, title: '자주하는 질문 < 이마티콘' },
    },
    {
      //배너 가이드
      path: "/emarticon/emarticonGuide",
      name: "emarticonGuide",
      component: emarticonGuide,
      meta: { layout: Default, title: '이마티콘 가이드 < 이마티콘' },
    },
    {
      //점포 시상 진입
      path: "/award/awardCode",
      name: "awardCode",
      component: awardCode,
      meta: { layout: Default, title: '점포 시상코드 입력 < 이마티콘' },
    },
    {
      //점포 시상 메인
      path: "/award/emarticonAwardHome",
      name: "emarticonAwardHome",
      component: emarticonAwardHome,
      meta: { layout: Default, requiresAuth: true, title: '점포 시상 < 이마티콘' },
    },
    {
      // 시상내역
      path: "/award/awardDetail",
      name: "awardDetail",
      component: awardDetail,
      meta: { layout: Default, requiresAuth: true, title: '시상내역 < 이마티콘' },
    },
    {
      // 이마티콘 설정
      path: "/myemarticon/setting",
      name: "setting",
      component: setting,
      meta: { layout: Default, requiresAuth: true, title: '이마티콘 설정' },
    },
    // 휴대폰인증 call window popup
    {
      path: "/commonCert/commPhoneCert",
      name: "phoneCert",
      component: () => import("@/components/cert/CertPhoneHtmlPopup.vue"),
    },
    // 휴대폰인증 result window popup
    {
      path: "/commonCert/callback/:certType",
      props: true,
      name: "phoneResult",
      component: () => import("@/components/cert/CertPhoneResultPopup.vue"),
    },
    // 비밀번호 설정
    {
      path: "/myemarticon/password",
      props: true,
      name: "mberPassword",
      component: EmarticonMberPassword,
      meta: { layout: Default, title: '비밀번호 설정' },
    },
  ],
});




router.beforeEach(async (to, from, next) => {
  if(to.path === '/myemarticon/paymentVoid' && from.path === '/myemarticon/savebox' ) {
    window.location.replace(window.location.origin + '/home');
  } else if(to.path === '/card/detail,' && from.path === '/') {
    window.location.replace(process.env.VUE_APP_EMART_SITE_NOWTRDEL);
  } else if(to.path === '/emarticon/card/autoCharging' && from.path === '/emarticon/card/autoCharging') { // 퀵계좌이체 등록 화면에서 돌아오면 히스토리 조작 처리
    window.location.replace(window.location.origin + '/home');
  }

  if(to.path === '/product/order-result' && from.path === '/home' && store.state.mberInfo.mberNo.substring(0,1) == 'C') { //시상용은 해당 로직 제외
    store.state.orderResultBack = true; // 홈 -> 구매/선물완료 뒤로가기 시 이마트앱 이동(이마트앱에서 뒤로가기 활성화)
    window.location.replace(process.env.VUE_APP_EMART_SITE_NOWTRDEL);
  }

  if(to.query.mberNo) { //parameter 회원번호 있으면 토큰 발급
    const response = await actions.GET_EMARTICON_TOKEN("GET_EMARTICON_TOKEN", to.query.mberNo);
    let mberNo = response.data.data.mberNo;
    if(mberNo){
        let mberInfo = {
            xScmToken : response.headers['x-scm-token'],
            xRefToken : response.headers['x-ref-token'],
            mberNo : mberNo
        }
        store.commit("setMberInfo", mberInfo);
    }

    if (to.query.isApp === "true") {
      if (to.query.hasOwnProperty('device')) {
        let isNewVersion;
        // if(to.query.device.toLowerCase().includes('andriod')) {
        if(to.query.device === 'emart.today.android') {
          store.commit("nativeStore/connect", ['and', to.query.appVersion]);

          isNewVersion = commonScripts.$compareVersions(to.query.appVersion, '5.1.2');
        // } else if (to.query.device.toLowerCase().includes('ios')) {
        } else if(to.query.device === 'emart.today.iphone') {
          store.commit("nativeStore/connect", ['ios', to.query.appVersion]);

          isNewVersion = commonScripts.$compareVersions(to.query.appVersion, '5.0.9');
        }

        const today = new Date();

        const firstBeginDate = new Date('2025-01-21T00:00:00');
        const secondBeginDate = new Date('2025-02-17T00:00:00');

        if (today >= firstBeginDate && today < secondBeginDate) {
          // 구버전: 비번/생체 사용 x
          // 신버전: 비번/생체 사용 가능
          if (!isNewVersion) {
            store.commit('setIsMberPwdAuthenticated');
          }
        }
      }
    } else {
      store.commit("nativeStore/connect", ['web']);
    }
  }

  // alert("router : " + store.state.nativeStore.connect);
  // alert("router : " + store.state.nativeStore.bridge);

  if (store.state.nativeStore.isApp && store.state.nativeStore.connect) {
    if (store.state.nativeStore.device === 'and') {
      store.commit("nativeStore/connect", ['and']);
    } else if (store.state.nativeStore.device === 'ios') {
      store.commit("nativeStore/connect", ['ios']);
    }

    // alert("router re : " + store.state.nativeStore.bridge);
  }

  // 마우스 스크롤 해제
  if (document.body.style.overflow === 'hidden') {
    document.body.style.overflow = 'auto'
  }

  console.log("to name ", to.path);
  console.log("from name ", from.path);

  if(to.meta.requiresAuth && !store.state.mberInfo.mberNo) { //메뉴 진입 권한체크
    store.commit("loginAlertPopup", [true, to.path]);
    const bodyHtml = document.body;
    bodyHtml.style.overflow = 'hidden'
  } else {
    next()
  }
});

router.afterEach((to) => {
  const title = to.meta.title === undefined ? '이마티콘' : to.meta.title;
  Vue.nextTick(() => {
    if(to.path == '/product/detail') {
      switch (to.query.orderType) {
        case('BUY'):
          document.title = '구매하기 < 이마티콘'
          break;
        case('GIFT'):
          document.title = '선물하기 < 이마티콘'
          break;
        default:
          document.title = title;
          break;
      }
    } else {
      document.title = title;
    }

  })
})
